<template>
  <div class="top_box">
    <div class="banner">
      <!-- <div class="title">{{ bannerMessage.title }}</div> -->
      <div class="title">专题专栏</div>
      <div class="line"></div>
      <div class="content">{{ bannerMessage.subtitle }}</div>
      <img :src="bannerMessage.thumbUrl" alt="" />
    </div>
    <div class="main_box">
      <div class="menu_box">
        <div
          class="left_menu"
          :style="{
            height:
              menuList.length < 10 ? 78 + menuList.length * 37 + 'px' : '448px',
          }"
        >
          <div class="left_title">
            <div class="title1">专题专栏</div>
            <div class="title2">ABOUT US</div>
          </div>
          <div class="left_item">
            <el-scrollbar style="width: 100%" wrap-style="overflow-y:auto;">
              <div
                class="item"
                v-for="(item, index) in menuList"
                :key="'item' + index"
                :class="{ choose: item.id === pushValue.specialId }"
                @click="changeItem(item.id)"
              >
                {{ item.title }}
              </div>
            </el-scrollbar>
          </div>
        </div>
        <div class="right_article" v-if="!ifShowDetail">
          <template v-if="backValue.length > 0">
            <div
              class="card_box"
              :class="{ card_boxsm: backValue.slice(0, 3).length < 3 }"
              v-if="backValue && backValue.length > 0"
            >
              <div
                class="pre_card"
                v-for="(item, index) in backValue.slice(0, 3)"
                :key="'card' + index"
              >
                <img
                  class="top_img"
                  :src="
                    item.thumbUrl ||
                    require(`@/assets/text/default${index}.jpg`)
                  "
                />
                <div class="bottom_box">
                  <div class="top_time">{{ item.timeline }}</div>
                  <div class="article_title">
                    {{ item.title }}
                  </div>
                  <div class="article">
                    {{ item.intro }}
                  </div>
                  <div class="bottom_btn" @click="chooseItem(item)">
                    更多 >>>
                  </div>
                </div>
              </div>
            </div>

            <div class="card_line">
              <div
                class="card_item"
                v-for="(item, index) in backValue.slice(3, 11)"
                :key="'list_card' + index"
                @click="chooseItem(item)"
              >
                <div class="time_box">
                  <div class="top">
                    {{
                      item.timeline.split(" ")
                        ? item.timeline.split(" ")[0].split("-")[2]
                        : item.timeline
                    }}
                  </div>
                  <div class="bottom">
                    {{ item.timeline.substring(0, 7) }}
                  </div>
                </div>
                <div class="line_middle"></div>
                <div class="article_box">
                  <div class="article_title">
                    {{ item.title }}
                  </div>
                  <div class="article">
                    {{ item.intro }}
                  </div>
                </div>
                <img
                  class="right_pic"
                  :src="
                    item.thumbUrl ||
                    require(`@/assets/text/default${index}.jpg`)
                  "
                  alt=""
                />
              </div>
            </div>

            <div class="page_box">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                @current-change="handleCurrentChange"
              />
            </div>
          </template>
          <div class="no_box" v-else>
            <img src="@/assets/text/nopicDe.png" alt="" />
            <div class="default_text">暂无数据</div>
          </div>
        </div>

        <div class="right_article2" v-else>
          <div class="small_title">
            <span
              @click="
                () => {
                  ifShowDetail = false;
                }
              "
              >返回</span
            >
          </div>
          <div class="article_box">
            <div class="title">{{ nowItem.title }}</div>
            <div class="time_style">发布时间：{{ nowItem.timeline }}</div>
            <img
              v-if="nowItem.thumbUrl"
              :src="nowItem.thumbUrl"
              alt=""
              onerror="this.onerror=null;this.src=defaultImg()"
            />
            <div class="article" v-html="normalizeRichText(nowItem.content)"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, watch, nextTick, onMounted } from "vue";
import api from "@/api/api";
import { normalizeRichText } from "@/utils/richText";
import { Search } from "@element-plus/icons-vue";
import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();
const defaultImg = () => {
  const numbers = [1, 2, 3, 4, 5];
  const randomIndex = Math.floor(Math.random() * numbers.length);
  return require(`@/assets/text/default${numbers[randomIndex]}.jpg`);
};
let backValue = ref([]);
let nowItem = ref({});
let ifShowDetail = ref(false);
let bannerMessage = ref({});
let pushValue = reactive({
  pageNo: 1,
  pageSize: 10,
  resourceId: 21,
  specialId: null,
  // title: "",
});
let total = ref(0);
let menuList = ref([
  {
    name: "领导关怀",
    key: 4,
  },
  {
    name: "集团要闻",
    key: 1,
  },
  {
    name: "成员动态",
    key: 2,
  },
]);
const changeItem = (key) => {
  pushValue.specialId = key;
  pushValue.pageNo = 1;
  ifShowDetail.value = false;
  router.push({
    query: {
      id: key,
    },
  });
  // getList();
};
const getBanner = async () => {
  let res = await api.getPageConfigDetail(85);
  if (res.code === "0") {
    bannerMessage.value = res.res.data;
  }
};
getBanner();
const getList = async () => {
  let res = await api.getArticlePage(pushValue);
  if (res.code === "0") {
    total.value = res.res.data.total;
    backValue.value = res.res.data.records;
  }
};
const handleSizeChange = (val) => {
  pushValue.pageNo = val;
  getList();
};
const chooseItem = (item) => {
  if (item.link) {
    window.open(item.link, "_blank");
  } else {
    ifShowDetail.value = true;
    nowItem.value = item;
  }
};
const handleCurrentChange = (val) => {
  pushValue.pageNo = val;
  nextTick(() => {
    getList();
  });
};
const searchList = () => {
  if (pushValue.title) {
    getList();
  }
};
const clearInput = () => {
  getList();
};

const getMenuList = async () => {
  let obj = {
    resourceId: 21,
    specialId: 0,
  };
  let res = await api.getZtzlList(obj);
  if (res.code === "0" && res.res.data) {
    let arr = res.res.data;
    menuList.value = [...arr];
  }
};
watch(
  () => route,
  (newval) => {
    if (newval && newval.query.id) {
      pushValue.specialId = newval.query.id * 1;
      nextTick(() => {
        getList();
      });
    }
    if (newval && newval.query.content) {
      ifShowDetail.value = true;
      nowItem.value.content = newval.query.content;
      nowItem.value.title = newval.query.title;
      nowItem.value.timeline = newval.query.timeline;
    }
  },
  { deep: true, immediate: true }
);
onMounted(() => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  getMenuList();
});
</script>
<style lang="less" scoped>
:deep(.el-input-group__append) {
  background-color: #ffffff;
  cursor: pointer;
}
:deep(.el-input__wrapper) {
  box-shadow: 1px 0 0 1px var(--el-input-border-color, var(--el-border-color))
    inset;
}
.no_box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .default_text {
    margin-top: 21px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #317eb2;
    line-height: 22px;
  }
  img {
    width: 291px;
    height: 209px;
  }
}
.time_style {
  color: #666;
  font-size: 14px;
  font-family: "微软雅黑", "Microsoft Yahei", "Arial";
  margin-bottom: 15px;
  text-align: center;
}
.card_line {
  .card_item {
    width: 100%;
    height: 146px;
    background: #fafafa;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    transition: transform 0.3s ease;
    cursor: pointer;
    .time_box {
      width: 146px;
      height: 100%;
      padding: 38px 0px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .top {
        font-family: LucidaGrande;
        font-size: 35px;
        color: #808080;
        line-height: 41px;
        font-style: normal;
      }
      .bottom {
        font-family: LucidaGrande;
        font-size: 16px;
        color: #9c9c9c;
        line-height: 19px;
        font-style: normal;
      }
    }
    .line_middle {
      width: 1px;
      height: 80px;
      background: #d1d1d1;
    }
    .article_box {
      flex: 1;
      padding: 0px 30px;
      .article_title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #333333;
        line-height: 25px;
        text-align: left;
        font-style: normal;
        margin-bottom: 9px;
      }
      .article {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #969696;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .right_pic {
      width: 12.6vw;
      height: 100%;
    }
  }

  .card_item:hover {
    box-shadow: 0px 0px 17px 0px rgba(176, 176, 176, 0.5);
    .time_box {
      background: #006ab1 !important;
      .top {
        color: #ffffff !important;
      }
      .bottom {
        color: #ffffff !important;
      }
    }
    .article_box {
      .article_title {
        color: #006ab1 !important;
      }
    }
    .line_middle {
      display: none;
    }
  }
}
.page_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 96px;
}
.card_boxsm {
  justify-content: flex-start !important;
  .pre_card {
    margin-right: 2.76vw !important;
  }
}
.card_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 37px 0px 47px 0px;
  box-sizing: border-box;
  .pre_card {
    position: relative;
    width: 21.93vw;
    max-width: 30%;
    height: 24.0625vw;
    box-sizing: border-box;
    // width: 421px;
    // height: 462px;
    background: #ffffff;
    border: 1px solid #dadada;
    transition: transform 0.3s ease;
    cursor: pointer;
    .top_img {
      width: 100%;
      height: 204px;
    }
    .bottom_box {
      padding: 0px 25px;
      box-sizing: border-box;
      .top_time {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #bcbdbe;
        // line-height: 20px;
        text-align: left;
        font-style: normal;
        margin: 10px 0px;
      }
      .article_title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #333333;
        text-align: left;
        font-style: normal;
        margin-bottom: 10px;
        line-height: 1.5;
        height: 3em;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .article {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #969696;
        line-height: 20px;
        text-align: justify;
        font-style: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      .bottom_btn {
        position: absolute;
        bottom: 22px;
        left: 25px;
        width: 103px;
        height: 25px;
        border-radius: 13px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #969696;
        border: 1px solid #b0b0b0;
        line-height: 25px;
        text-align: center;
        font-style: normal;
        cursor: pointer;
      }
    }
  }
  .pre_card:hover {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
    .bottom_box {
      .article_title {
        color: #006ab1 !important;
      }
      .bottom_btn {
        border: none !important;
        background: #006ab1 !important;
        color: #ffffff !important;
      }
    }
  }
}
.top_input {
  width: 666px;
  height: 70px;
  background: #ffffff;
}
.top_box {
  width: 100%;
  .banner {
    width: 100%;
    height: 427px;
    position: relative;
    .title {
      position: absolute;
      left: 170px;
      top: 120px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 44px;
      color: #ffffff;
    }
    .line {
      position: absolute;
      left: 170px;
      top: 223px;
      width: 60px;
      height: 2px;
      background: rgba(255, 255, 255, 0.4);
    }
    .content {
      position: absolute;
      left: 170px;
      top: 254px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #ffffff;
    }
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: -1;
    }
  }
  .main_box {
    width: 100%;
    // 底部留白用固定值：原来 14.82vh 会让窗口越高留白越多（2000 高的窗口就是 296px）
    padding: 2.87vh 8.33vw 42px 8.33vw;
    box-sizing: border-box;
    .menu_box {
      display: flex;
      .left_menu {
        // height: 226px;
        width: 180px;
        background: #f0f0f0;
        margin-right: 63px;
        z-index: 3;
        .left_title {
          width: 100%;
          height: 74px;
          background: #006ab1;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: center;
          .title1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #ffffff;
            margin-right: 17px;
          }
          .title2 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
            margin-right: 17px;
            margin-top: 4px;
          }
        }
        .left_item {
          height: calc(100% - 74px);
          .item {
            cursor: pointer;
            text-align: right;
            height: 37px;
            line-height: 37px;
            padding-right: 17px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
          }
          .choose {
            background: #223e62 !important;
            color: #ffffff !important;
          }
        }
      }
      .right_article {
        // z-index: 3;
        width: calc(100% - 243px);
      }
      .right_article2 {
        width: calc(100% - 243px);
        box-sizing: border-box;
        .small_title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 14px;
          color: #999999;
          line-height: 20px;
          text-align: left;
          font-style: normal;
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 14px;
            color: #999999;
            line-height: 20px;
            font-style: normal;
            cursor: pointer;
          }
        }

        .article_box {
          .title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 48px;
            color: #333333;
            line-height: 67px;
            font-style: normal;
            text-align: center;
            margin: 35px 0px 42px 0px;
          }
          img {
            width: 100%;
            height: 564px;
          }
          .article {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #333333;
            line-height: 30px;
            text-align: left;
            font-style: normal;
            margin-top: 36px;
            padding-bottom: 36px;
          }
          .detail_list {
            div {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 16px;
              color: #333333;
              line-height: 30px;
              text-align: left;
              font-style: normal;
            }
          }
        }
      }
    }
  }
}
</style>
